import fs from 'fs';
import {spawnSync} from 'child_process';

import {parseVersion} from './util.js';

/**
 * @return {Array}
 */
export function version() {
	const out = runInGradle('lnk_get_version', `println gradle.gradleVersion`);

	if (!out) {
		return out;
	}

	return parseVersion(out);
}

/**
 * @return {Array}
 */
export function nodePluginVersion() {
	const out = runInGradle(
		'lnk_get_node_plugin_version',
		`buildscript.configurations.classpath.each { println it.name}`
	);

	if (!out) {
		return out;
	}

	const lines = out.split('\n');

	const pluginLines = lines.filter(line =>
		line.startsWith('com.liferay.gradle.plugins.node-')
	);

	if (pluginLines.length != 1) {
		return undefined;
	}

	const parts = pluginLines[0].split('-');

	if (parts.length != 2) {
		return undefined;
	}

	const version = parts[1].replace('.jar', '');

	return parseVersion(version);
}

/**
 * @param {String} task
 * @param {String} taskScript
 * @return {String}
 */
function runInGradle(task, taskScript = '') {
	const buildGradleContent = fs.readFileSync('build.gradle');

	try {
		fs.writeFileSync(
			'.build.gradle.liferay.npm.sdk',
			`
${buildGradleContent}
task ${task} << {
	println "{${task}}"
	${taskScript}
	println "{${task}}"
}
			`
		);

		const proc = spawnSync('gradle', [
			'-b',
			'.build.gradle.liferay.npm.sdk',
			task,
		]);

		const out = proc.output.toString();
		const parts = out.split(`{${task}}`);

		if (parts.length != 3) {
			return undefined;
		}

		return parts[1];
	} finally {
		fs.unlinkSync('.build.gradle.liferay.npm.sdk');
	}
}
